import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import Content from "../sections/login/Content";
// import Header from "../layouts/Headerfour";
import Header from "../layouts/Headerfour";
const Login = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Buy Home For Less | Login</title>
        <meta name="description" content="#" />
      </Helmet>
      <Header />
     

      <Content />

    </Fragment>
  );
};

export default Login;
